import { Popup } from "@bryntum/core-thin";

const defaultProps = {
  autoShow: false,
  centered: true,
  closable: false,
  autoClose: false,
  closeAction: "destroy",
};

const popupSelector = {
  grid: Popup,
  gantt: Popup,
};

/**
 * This is a class for building a popup element.
 * Its constructor takes an object and 2 callbacks as parameters.
 *
 * The object is for the configs of the popup.
 *
 * The first callback is used for the submit, it takes the array of all the values that are given
 * in the popup on submit as a first parameter, and the popup as a second parameter.
 *
 * The second callback is used to handle side effects when the popup is closing. It takes the popup as a parameter.
 *
 * The goal here is to handle potential asynchronous logic to close the popup after a promise is got from the backend.
 */
export default class PopupBuilder {
  #defaultBbar = {
    items: {
      cancel: {
        text: "Cancel",
        minWidth: 100,
        onAction: (event) => {
          this.closeCallback(event.source.parent.parent);
        },
      },
      close: {
        text: "OK",
        minWidth: 100,
        cls: "b-raised b-blue",
        onAction: (event) => {
          const { items } = event.source.parent.parent;
          const isGrid = items[0].isGrid;
          if (isGrid) {
            this.submitCallback(items[0].data, this.popup);
          } else {
            const values = Object.values(event.source.parent.parent.items).map(
              (val) => val.value
            );
            this.submitCallback(values, this.popup);
          }
        },
      },
    },
  };

  #defaultSubmitCallback = (values, popup) => {
    popup.close();
  };
  constructor(
    {
      header = "Popup",
      width = "25rem",
      height = "18em",
      items = {},
      bbar = {},
      ...popupProps
    },
    submitCallback = this.#defaultSubmitCallback,
    closeCallback = "up.close"
  ) {
    this.header = header;
    this.width = width;
    this.height = height;
    this.popupProps = popupProps;
    this.bbar = { items: { ...bbar, ...this.#defaultBbar.items } };
    this.items = items;
    this.submitCallback = submitCallback;
    this.closeCallback = closeCallback;
  }

  buildPopup(instanceName = "gantt") {
    const header = this.header;
    const width = this.width;
    const minHeight = this.height;
    const bbar = this.bbar;
    const items = this.items;
    const onAction = this.submitCallback;
    this.popup = new Popup({
      header,
      width,
      minHeight,
      bbar,
      items,
      positioned: true,
      onAction,
      ...defaultProps,
      ...this.popupProps,
    });
    return this.popup;
  }
}
